import { useState } from 'react'

const ModalHook = () => {
  const [isOpen, setOpen] = useState(false)

  return [isOpen, setOpen]
}

export default ModalHook
